import React, { useEffect, useRef, useState } from "react";
import Cart from "@system/config/cart";
import ClearCart from "../Cart/ClearCart";
import closeIc from "src/assets/images/close-ic.png";
import ClearSingleCartProductFromCart from "../Cart/ClearSingleCartProductFromCart";
import DOMAttachToSystem from "../../captain/DOMAttachToSystem";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import $ from "jquery";
import liveAuth from "src/helper/liveAuth";
import System from "src/helper/system";
import Helper from "src/helper/Helper";
import useDebounce from "../../hooks/useDebounce";
import noImage from "src/assets/images/noimage.png";
import AxiosIndicatorRunTimeLoader from "src/component/Global/AxiosIndicatorRunTimeLoader";
import { useCartStore } from "src/hooks/cart";
import { isNumber } from 'underscore';
import { __set, __remove } from "src/store/axios_indicator";
import NavigateToProductDetail from "../../component/custom/NavigateToProductDetail";
import { useBOMStore } from "src/hooks/bom";
import Constants from "src/helper/Constants";
import Bom from "@system/config/bom";
import Cookies from "js-cookie";
import { useSystem } from "src/hooks/system";

const HeaderTotalCartItems = () => {
  const [__check] = useAxiosIndicatorCheck();
  const cartDropDown = useRef(null);
  const [CART_DATA_d, Set_CART_DATA_d] = useDebounce([], 100);
  const [{ CART_DATA, CART_COUNT, CART_SUB_TOTAL }, { fetch_cart_count, fetch_cart_data, merge_Guest_Cart_Items }, { }] = useCartStore();
  const isFromCart = System.isCallFromCart();
  const [{ }, { merge_Guest_Bom_Items, fetch_bom_project_detail_with_bom }, { }] = useBOMStore();
  const { currencyType: { USD }, siteUser: { CORE, WEB }, BomPages } = Constants
  const { storageName: { GUEST_SESSION_ID, CART_ID, GUEST_BOM_ID }, avUserInfoData: { currentUser } } = System
  const [loader, setLoader] = useState(false);
  const [,{ get_quantity_format }] = useSystem();

  const checkSession = async () => {
    if (liveAuth.check() && localStorage.getItem(GUEST_SESSION_ID)) {
      if (!isFromCart && localStorage.getItem(CART_ID) && ((currentUser === CORE && System.getUserShippingAddress()) || (currentUser === WEB))) {
        await merge_Guest_Cart_Items()
      }

      if (localStorage.getItem(GUEST_BOM_ID)) {
        const bomRes = await merge_Guest_Bom_Items()
        if (bomRes?.isSuccessFull) {
          localStorage.removeItem(GUEST_BOM_ID)
          fetch_bom_project_detail_with_bom()
          if (BomPages.BomDetailById.param_value === System.getParams().__c) {
            window.location.href = Bom.getBomRouteURL()
          }
        }
      }
      localStorage.removeItem(GUEST_SESSION_ID)
    }

    await fetchFromServer();
  }

  useEffect(() => {
    function fetchHere() {
      $(document).on("click", ".dropdown-menu", function (e) {
        e.stopPropagation();
      });
    }
    checkSession()
    fetchHere();
  }, []);

  useEffect(() => {
    async function fetchHere() {
      Set_CART_DATA_d(CART_DATA);
    }
    fetchHere()
  }, [CART_DATA]);

  useEffect(() => {
    const preventCloseHandle = (e) => {
      const cartmodal = document.getElementById("cart-popup");
      if (cartmodal?.contains(e.target)) {
        cartDropDown.current.className = "dropdown cartCountWidget open"
      }
    }

    function closeDropdown(event) {
      let cartElem = document?.getElementById("dvCartCountWidget");
      if (cartElem && !cartElem.contains(event.target)) {
        cartElem.classList.remove("open");
        cartElem.removeAttribute("data-toggle");
      }
    }
    document.addEventListener("click", closeDropdown);
    document.addEventListener("click", preventCloseHandle);
    return () => {
      document.removeEventListener("click", closeDropdown);
      document.removeEventListener("click", preventCloseHandle);
    }
  });

  useEffect(() => {
    // Close Account Dropdown if Exist
    let accountDropdown = document?.getElementById("av-account-trigger");
    const hideCart = () => {
      let cartElem = document?.getElementById("dvCartCountWidget");
      if (cartElem && cartElem.classList?.contains("open")) {
        cartElem.removeAttribute("class");
        cartElem.setAttribute("class", "dropdown cartCountWidget");
      }
    };
    accountDropdown?.addEventListener("click", hideCart);
    return () => {
      accountDropdown?.removeEventListener("click", hideCart);
    };
  }, []);

  const authLoggedIn = () => {
    return liveAuth.check();
  };


  const fetchFromServer = async () => {
    __set('MINI_CART_API_CALL');
    if (!Cookies.get(System.storageName.CART_COUNT))
      fetch_cart_count()
    __remove('MINI_CART_API_CALL');
  };

  const fetchDataFromServer = async () => {
    if (Object.entries(CART_DATA)?.length === 0) {
      __set('MINI_CART_API_CALL');
      await fetch_cart_data({ miniCart: true });
      __remove('MINI_CART_API_CALL');
    }
  };

  const openCart = async (e) => {
    await fetchDataFromServer();
    document.querySelectorAll("li")
      .forEach((item) => item.classList.remove("open"));

    // Close Account Dropdown if Exist
    if (authLoggedIn() === true) {
      let accountDropdown = document.getElementById("listing");
      if (accountDropdown && accountDropdown.classList.contains("open")) {
        accountDropdown.removeAttribute("class");
      }
    }
  };

  const getUnitPrice = (unitPrice) => {
    return System.getFormatNumber({ amount: Number(unitPrice), currency: USD });
  }

  const getProductCartRedirectionLink = (v) => {
    if (v && v[1]?.isProductAvailableFromMainAPI) {
      return `/${System.avUserInfoData.speedBoatNameLower}/manufacturers/m/${Helper.replaceSpecialChar(v[1].manufacturerName?.toLowerCase())}/`
    }
    return '#';
  }

  return (
    <>
      <DOMAttachToSystem />
      <div id='dvCartCountWidget' ref={cartDropDown} className="dropdown cartCountWidget">

        <button type="button" className="bs5 btn btn-secondary rounded-1 dropdown-toggle ms-2 header-cart-toggle"
          data-toggle='dropdown' onClick={(e) => openCart(e)}>
          <span className="ms-1 d-none d-md-inline-block text-black">
            <b>
              {<>{System.getCurrentCartCount()}</>}
            </b>
            <div>ITEM(S)</div>
          </span>
          <i className="fa fa-shopping-cart text-black" />
        </button>
        <div className="dropdown-menu dropdown-menu-right mini-cart mt-3" id="cart-popup">
          <div className="mini-cart-head">
            <h6>MY CART</h6>
          </div>
          {CART_DATA_d && Object.entries(CART_DATA_d).length > 0 && !__check('MINI_CART_API_CALL').status && System.getCurrentCartCount() > 0 ?
            <>
              <div className="mini-cart-body">
                <div className="bs5 row mini-cart-detail m-0">
                  <div className="col-8">
                    <strong className="font-arial font-16">
                      ({System.getCurrentCartCount()}) ITEM(S) IN CART
                    </strong>
                  </div>
                  <div className="col-4 text-end">
                    <ClearCart />
                  </div>
                </div>
                <div className="table-responsive">
                  <table>
                    <tbody>
                      {Object.entries(CART_DATA_d).map((v) => (
                        <tr key={v[1].ItemNumber}>
                          <td className="pe-0 w80">
                            <div className="product-img sect-1 text-center">
                              <img src={v[1].assetURL && v[1].assetURL.trim() !== "" ? v[1].assetURL : noImage} />

                            </div>
                          </td>

                          <td>
                            <div className={v[1]?.isProductAvailableFromMainAPI === false ? "product-name text-black" : "product-name"}>
                              {v[1]?.isProductAvailableFromMainAPI &&
                                <>

                                  <NavigateToProductDetail
                                    data={{ ManufacturerName: v[1]?.manufacturerName, ERPMFRPartNumber: v[1]?.ERPMFRPartNumber, ItemNumber: v[1]?.ItemNumber, ERPPartNumber: v[1]?.ERPPartNumber }}>
                                    <strong>
                                      {v[1].ERPMFRPartNumber}
                                    </strong>
                                    <br />
                                  </NavigateToProductDetail>
                                </>
                              }
                              {!v[1]?.isProductAvailableFromMainAPI && (
                                <strong>{v[1].ERPMFRPartNumber}</strong>
                              )}
                              {v[1].manufacturerName && (
                                <a href={getProductCartRedirectionLink(v)} className="mt1 text-black" >
                                  by{" "}
                                  {v[1].manufacturerName}
                                </a>
                              )}
                            </div>
                          </td>

                          <td className="mini-cart-pricing pe-0">
                            <div className="bs5 row">
                              <div className="col-6">Unit Price:</div>
                              <div className="col-6 text-end font_bold_currency">
                                {" "}
                                {getUnitPrice(v[1].unitPrice) || 0}
                              </div>
                            </div>
                            <div className="bs5 row">
                              <div className="col-6">Quantity:</div>
                              <div className="col-6 text-end font_bold_currency">
                                {" "}
                                {get_quantity_format(v[1].quantity)}
                              </div>
                            </div>
                          </td>

                          <td className="ps-0 pt-2 pe-2">
                            <ClearSingleCartProductFromCart currentCartItem={v[1]} >
                              <div className="close-ic text-end">
                                <img src={closeIc} />
                              </div>
                            </ClearSingleCartProductFromCart>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="bs5 row m-0 mini-cart-item-total">
                  <div className="col-7 px-0">
                    <span><span className="cart-item-count"> </span>Items Subtotal ({USD}):</span>
                  </div>
                  <div className="col-5 text-end font_bold_currency ps-1" >
                    <span className="font_bold_currency">{isNumber(CART_SUB_TOTAL) ? System.getFormatNumber({ amount: Number(CART_SUB_TOTAL), currency: USD, maximumFractionDigits: 2 }) || 0 : ""}</span>
                  </div>
                </div>
              </div>
            </>
            :
            CART_DATA_d && Object.entries(CART_DATA_d).length === 0 && !__check('MINI_CART_API_CALL').status && System.getCurrentCartCount() == 0 ? <>
              <div className="mini-cart-body">
                <div className="empty-cart">Your Cart is Empty</div>
              </div>
            </> : <AxiosIndicatorRunTimeLoader />
          }
          {System.getCurrentCartCount() > 0 &&
            (<div className="mini-cart-btn">
              <button className="bs5 btn btn-primary d-block most-viewd-item-btn w-100"
                onClick={() => {
                  setLoader(true);
                  window.location.href = Cart.getCartPageRouteURL();
                }}
                disabled={loader}>
                {loader ? <i className="fa fa-spinner fa-spin" /> : "VIEW CART"}
              </button>
            </div>)
          }

        </div>

      </div>

    </>
  );
};

export default HeaderTotalCartItems;
